export const BRAND_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_geoplan-work/artifacts/o4av1ja3_grok_image_1788632536548.jpg";
export const ASK_IMG =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_geoplan-work/artifacts/v2qf3zvd_grok_image_1788632742904.jpg";

// variant: "brand" (faint mascot watermark) | "ask"/"office" (full dark office scene)
export function SiteBackground({ variant = "brand" }) {
  if (variant === "ask" || variant === "office") {
    const overlay = variant === "ask"
      ? "linear-gradient(180deg, rgba(6,8,16,0.72), rgba(6,8,16,0.82))"
      : "linear-gradient(180deg, rgba(6,8,16,0.55), rgba(6,8,16,0.66))";
    return (
      <>
        <div
          aria-hidden
          className="fixed inset-0 pointer-events-none"
          style={{
            zIndex: 0,
            backgroundImage: `url(${ASK_IMG})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
        />
        <div
          aria-hidden
          className="fixed inset-0 pointer-events-none"
          style={{ zIndex: 0, background: overlay }}
        />
      </>
    );
  }
  return (
    <div
      aria-hidden
      className="fixed inset-0 pointer-events-none hidden sm:block"
      style={{
        zIndex: 0,
        backgroundImage: `url(${BRAND_IMG})`,
        backgroundRepeat: "no-repeat",
        backgroundPosition: "right bottom",
        backgroundSize: "auto 96%",
        opacity: 0.9,
      }}
    />
  );
}
